import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ListComponent } from '../list-component';
import { Envelope } from '../../interfaces/envelopes/envelope';
import { eOrderStatusType } from '../../enums';
import { EnvelopeRepositoryService } from '../../services/envelopes/envelope-repository.service';
import { Utilities } from '../../utilities';
import { Router } from '@angular/router';
import { EnumLabelService } from '../../services/enum-label/enum-label.service';

@Component({
    selector: 'lib-hub-reports-grid',
    templateUrl: './hub-reports-grid.component.html',
    styleUrl: './hub-reports-grid.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HubReportsGridComponent extends ListComponent<Envelope> {
  private readonly enumLabels = inject(EnumLabelService);
  protected columnsToDisplay = [
    'reference',
    'jurisdiction',
    // 'status',
    'statusLastUpdated',
    'numOrders',
    'view'
  ];
  protected _expandedEnvelope: Envelope | null = null;

  constructor(
    repo: EnvelopeRepositoryService,
    private router: Router) {
    super(repo);
  }

  getReference(envelope: Envelope) {
    if (envelope.reference) {
      return envelope.reference;
    } else {
      return envelope.envelopeOrders?.find(eo => !eo.parentEnvelopeOrderID)?.orderReferenceNumber ?? '';
    }
  }

  getJurisdiction(envelope: Envelope) {
    if (envelope.jurisdiction === '_F') {
      return 'FED';
    } else {
      return envelope.jurisdiction;
    }
  }

  getStatus(envelope: Envelope) {
    const envelopeOrders = envelope.envelopeOrders?.filter(eo => eo.orderStatus !== eOrderStatusType.cancelled) ?? [];

    if (envelopeOrders.length === 0) {
      return 'N/A';
    } else if (envelopeOrders.some(eo => eo.orderStatus === eOrderStatusType.awaitingExternalInformation)) {
      return this.enumLabels.label('orderStatusType', eOrderStatusType.awaitingExternalInformation);
    } else if (envelopeOrders.some(eo => eo.orderStatus === eOrderStatusType.pending)) {
      return this.enumLabels.label('orderStatusType', eOrderStatusType.pending);
    } else if (envelopeOrders.every(eo => eo.orderStatus === eOrderStatusType.complete)) {
      return eOrderStatusType.complete;
    } else {
      return 'N/A';
    }
  }
  
  protected viewEnvelope(envelope: Envelope, newTab: boolean) {
    const castedRepo = this.repo as EnvelopeRepositoryService;
    castedRepo.selectedEnvelope = envelope;

    if (newTab) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['hubreports', envelope.id])
      );

      window.open(url, '_blank');
    }
    else {
      this.router.navigate(['hubreports', envelope.id])
    }
  }
}
